import { TextPassage } from '@petsmart-ui/sparky';
import type { InventoryProps } from './types';

enum InventoryClassName {
    in_stock = 'sparky-u-color-utility-success',
    low_stock = 'sparky-u-color-utility-warning',
    out_of_stock = 'sparky-u-color-utility-error',
}

enum InventoryText {
    in_stock = 'In stock',
    low_stock = 'Only a few left',
    out_of_stock = 'Out of stock',
}

export default function Inventory({
    isAvailable,
    availableToSell,
}: InventoryProps) {
    let classNameBase;
    let inventoryText;
    const lowStockThreshold = 5;

    if (!isAvailable || !availableToSell) {
        classNameBase = InventoryClassName.out_of_stock;
        inventoryText = InventoryText.out_of_stock;
    } else if (availableToSell <= lowStockThreshold) {
        classNameBase = InventoryClassName.low_stock;
        inventoryText = InventoryText.low_stock;
    } else {
        classNameBase = InventoryClassName.in_stock;
        inventoryText = InventoryText.in_stock;
    }

    return (
        <TextPassage className={`delivery-method-status ${classNameBase}`}>
            {inventoryText}
        </TextPassage>
    );
}
